// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Estedad-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Estedad-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `   /* ---------- فونت ---------- */
   @font-face {
       font-family: Estedad-Regular;
       src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
   }

   @font-face {
       font-family: Estedad-Bold;
       src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
   }

   /* ---------- متغیرها ---------- */
   :root {
       --bg: #f3f4f6;
       --panel: #ffffff;
       --muted: #9aa3af;
       --text: #0f172a;
       --ring: #e5e7eb;
       --shadow: 0 10px 25px rgba(0, 0, 0, .06), 0 1px 2px rgba(0, 0, 0, .05);
       --green: #10b981;
       --red: #ef4444;
       --mainColor: #EA6C22;
   }

   /* ---------- عمومی ---------- */
   * {
       box-sizing: border-box;
   }

   body {
       margin: 0;
       font-family: Estedad-Regular;
       background: var(--bg);
       color: var(--text);
       
   }

/* ---------------------------------------------------------
   🌐 Global Inputs Style (بدون متغیر)
   ---------------------------------------------------------
   طراحی مدرن:
   - گوشه‌های نرم
   - رنگ‌بندی خنثی
   - افکت فوکوس با سایه لطیف
--------------------------------------------------------- */

/* فقط برای input های متنی و textarea معمولی اعمال شود */
/* input[type="text"],
input[type="number"],
textarea:not(#paymentNote) { 
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 12px;
  outline: none;
  transition: all 0.2s ease-in-out;
  margin: 10px 0;

  &::placeholder {
    color: #999;
    font-size: 14px;
    text-align: right;
  }

  &:focus {
    border-color: #EA6C22;
    box-shadow: 0 0 0 3px rgba(76, 154, 255, 0.2);
  }

  &:disabled {
    background-color: #f5f5f5;
    border-color: #ddd;
    color: #999;
    cursor: not-allowed;
  }

  &.is-error {
    border-color: #e74c3c;
    box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.2);
  }
} */

/* رادیو باتن ها */
/* input[type="radio"] {
  width: auto; 
  height: auto;
  margin: 0;
  padding: 0;
  accent-color: #EA6C22; 
} */
/* 
#paymentNote {
  width: 100%;
  resize: vertical;
  min-height: 80px;
  padding: 0.75rem 1rem;
  border-radius: 12px;
} */

.invoice-explanation{
  margin-top: 30px;
}



.radio-label{
  margin-left: 10px;
}


label.checkbox-label {
    margin-left: 20px;
}

/* .pagination {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
.page-btn {
  padding: 0.4rem 0.8rem;
  border: 1px solid #ccc;
  background: #fff;
  cursor: pointer;
  border-radius: 4px;
}
.page-btn.active {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}

th,td{
  text-align: right !important;
}
 */

/* ================================
   Table Responsive Scroll Styles
   ================================ */

/* .table-container {
  width: 100%;
  overflow-x: auto; 
  -webkit-overflow-scrolling: touch; 
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

.table-container table {
  width: 100%; 
  border-collapse: collapse; 
}

.table-container th,
.table-container td {
  padding: 0.75rem; 
  text-align: center;
  white-space: nowrap; 
}

.table-container thead {
  background: #f5f5f5; 
}
 */


@media (max-width:820px) {

 .table-container {
  width: 300px
 
}
}


.button-group-header-card {
    display: flex;
    gap: 10px; /* فاصله بین دکمه‌ها */
    flex-wrap: nowrap; /* جلوگیری از شکست خط */
}




.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 10px;
  font-family: sans-serif;


  width: 50%;
  margin: 20px auto 0 auto; /* ← این باعث وسط شدن افقی میشه */
}


.pagination button {
  border: none;
  background-color: #f2f2f2;
  color: #333;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.pagination button:hover:not(:disabled) {
  background-color: #e0e0e0;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination button.active {
  background-color: #EA6C22;
  color: #fff;
}

.pagination .dots {
  padding: 0 6px;
  color: #999;
}















.role-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  z-index: 10;
  min-width: 120px;
}

.role-dropdown div {
  padding: 6px 12px;
  cursor: pointer;
}

.role-dropdown div:hover {
  background-color: #f0f0f0;
}


.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  border-radius: 6px;
  z-index: 100;
  min-width: 120px;
}

.dropdown div {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown div:hover {
  background: #f0f0f0;
}



/* ---------------------------------------------
 🎯 Search Input Field Styles
 Author: بنیامین حیدرزاده
 Description: Elegant animated search bar with hover/focus effects
----------------------------------------------*/

.search-container {
  position: relative;
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  /* 🕶️ subtle fade-in animation */
  animation: fadeInSearch 0.6s ease forwards;
}

@keyframes fadeInSearch {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* ---------- سرچ باکس ---------- */
.search-container {
  position: relative;
  width: 240px;
  transition: all 0.3s ease;
}

.search-container:focus-within {
  width: 280px; /* بزرگ‌تر شدن هنگام فوکوس */
}

.search-input {
  width: 100%;
  padding: 0.6rem 1rem 0.6rem 2.5rem;
  border: 1.5px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #333;
  font-size: 15px;
  outline: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.search-input::placeholder {
  color: #aaa;
}

.search-input:focus {
  border-color: #ff6b00;
  box-shadow: 0 0 0 3px rgba(255, 107, 0, 0.15);
}

.search-container::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 50%;
  width: 18px;
  height: 18px;
  transform: translateY(-50%);
  /* background: url("/icons/search.svg") no-repeat center; */
  background-size: contain;
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.search-container:hover::before {
  opacity: 1;
}

/* ---------- گروه دکمه‌ها ---------- */
.button-group-header-card {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

/* ---------- ریسپانسیو ---------- */
@media (max-width: 768px) {
  .header-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .search-container {
    width: 100%;
  }

}






.scroll-to-top-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #ff7a00;
  color: white;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  transition: transform 0.2s ease, opacity 0.2s ease;
  z-index: 1000;
}

.scroll-to-top-btn:hover {
  transform: translateY(-3px);
  opacity: 0.9;
}












/* ============================
  جمع کل محصولات
============================ */
.total-amount {
  font-weight: bold;
  font-size: 16px;
  color: #333;
  margin-top: 1rem;
}

/* ============================
  بخش تسویه
============================ */
.payment-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.payment-section .remaining-amount {
  font-weight: bold;
  font-size: 16px;
  color: #EA6C22;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border: 1px solid #EA6C22;
  background-color: #fff4f0;
  box-shadow: 0 2px 6px rgba(234,108,34,0.2);
}

/* ============================
  چک‌باکس‌ها و جزئیات پرداخت
============================ */
.payment-type {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #EA6C22;
}

.payment-details {
  margin-top: 0.5rem;
  padding: 0.75rem 1rem;
  border-left: 4px solid #EA6C22;
  border-radius: 8px;
  background-color: #fff8f3;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.payment-details .form__input,
.payment-details textarea {
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.payment-details .form__input:focus,
.payment-details textarea:focus {
  border-color: #EA6C22;
  box-shadow: 0 0 6px rgba(234,108,34,0.3);
  outline: none;
}

.payment-details textarea {
  resize: vertical;
  min-height: 60px;
}

.payment-error {
  color: #EA6C22;
  font-weight: bold;
  font-size: 14px;
  margin-top: 0.25rem;
}






/* ---------- Simple Tabs ---------- */

.tabs-container {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.tab-button {
  padding: 8px 16px;
  border: none;
  background: transparent;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  transition: color 0.2s ease;
}

.tab-button:hover {
  color: #ff6600; /* هاور ساده */
}

.tab-button.active {
  font-weight: bold; /* بولد شدن تب فعال */
  color: #000;
}













/* ===============================
   📱 Phone Input Floating Label
================================= */
.phone-input-container {
  position: relative;
  width: 100%;
  margin: 20px 0;
}

.phone-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.phone-prefix {
  position: absolute;
  left: 1px;
  color: #888;
  font-size: 15px;
  pointer-events: none;
}

.phone-input {
  width: 100%;
  padding: 14px 12px 14px 3rem; /* فضای کافی برای "09" */
  border: 2px solid #a1a1a1;
  border-radius: 8px;
  font-size: 15px;
  direction: ltr;
  text-align: left;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

/* فوکوس */
.phone-input:focus {
  outline: none;
  border-color: #EA6C22;
  box-shadow: 0 4px 12px rgba(234, 108, 34, 0.3);
}

/* لیبل شناور */
.phone-label {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background-color: #fff;
  color: #555;
  font-size: 15px;
  pointer-events: none;
  transition: all 0.25s ease-in-out;
}

/* وقتی فوکوس یا مقدار دارد */
.phone-input:focus ~ .phone-label,
.phone-input:not(:placeholder-shown) ~ .phone-label {
  top: 0;
  font-size: 13px;
  color: #EA6C22;
  padding: 0 6px;
}

/* حالت خطا */
.has-error {
  border-color: #e74c3c !important;
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.15);
}

.phone-error {
  color: #e74c3c;
  font-size: 13px;
  margin-top: 6px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"GAAG,+BAA+B;GAC/B;OACI,4BAA4B;OAC5B;GACJ;;GAEA;OACI,yBAAyB;OACzB,4CAAqC;GACzC;;GAEA,kCAAkC;GAClC;OACI,aAAa;OACb,gBAAgB;OAChB,gBAAgB;OAChB,eAAe;OACf,eAAe;OACf,sEAAsE;OACtE,gBAAgB;OAChB,cAAc;OACd,oBAAoB;GACxB;;GAEA,gCAAgC;GAChC;OACI,sBAAsB;GAC1B;;GAEA;OACI,SAAS;OACT,4BAA4B;OAC5B,qBAAqB;OACrB,kBAAkB;;GAEtB;;AAEH;;;;;;;2DAO2D;;AAE3D,wDAAwD;AACxD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqCG;;AAEH,kBAAkB;AAClB;;;;;;GAMG;AACH;;;;;;;GAOG;;AAEH;EACE,gBAAgB;AAClB;;;;AAIA;EACE,iBAAiB;AACnB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE;;AAEF;;qCAEqC;;AAErC;;;;;;;;;;;;;;;;;;;;;;;EAuBE;;;AAGF;;CAEC;EACC;;AAEF;AACA;;;AAGA;IACI,aAAa;IACb,SAAS,EAAE,sBAAsB;IACjC,iBAAiB,EAAE,uBAAuB;AAC9C;;;;;AAKA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,uBAAuB;;;EAGvB,UAAU;EACV,wBAAwB,EAAE,iCAAiC;AAC7D;;;AAGA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;;;;;;;;;;;;;;;AAgBA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;;;;+CAI+C;;AAE/C;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY,EAAE,4BAA4B;AAC5C;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2DAA2D;EAC3D,wBAAwB;EACxB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;AAEF;;;;;;;AAOA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;;;;;;;;;;;;AAaA;;8BAE8B;AAC9B;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;8BAE8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;8BAE8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;;;;;;AAOA,sCAAsC;;AAEtC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,iBAAiB,EAAE,qBAAqB;EACxC,WAAW;AACb;;;;;;;;;;;;;;AAcA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B,EAAE,wBAAwB;EACtD,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0DAA0D;EAC1D,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;;EAEE,MAAM;EACN,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB","sourcesContent":["   /* ---------- فونت ---------- */\n   @font-face {\n       font-family: Estedad-Regular;\n       src: url(../fonts/Estedad-Regular.woff2)\n   }\n\n   @font-face {\n       font-family: Estedad-Bold;\n       src: url(../fonts/Estedad-Bold.woff2);\n   }\n\n   /* ---------- متغیرها ---------- */\n   :root {\n       --bg: #f3f4f6;\n       --panel: #ffffff;\n       --muted: #9aa3af;\n       --text: #0f172a;\n       --ring: #e5e7eb;\n       --shadow: 0 10px 25px rgba(0, 0, 0, .06), 0 1px 2px rgba(0, 0, 0, .05);\n       --green: #10b981;\n       --red: #ef4444;\n       --mainColor: #EA6C22;\n   }\n\n   /* ---------- عمومی ---------- */\n   * {\n       box-sizing: border-box;\n   }\n\n   body {\n       margin: 0;\n       font-family: Estedad-Regular;\n       background: var(--bg);\n       color: var(--text);\n       \n   }\n\n/* ---------------------------------------------------------\n   🌐 Global Inputs Style (بدون متغیر)\n   ---------------------------------------------------------\n   طراحی مدرن:\n   - گوشه‌های نرم\n   - رنگ‌بندی خنثی\n   - افکت فوکوس با سایه لطیف\n--------------------------------------------------------- */\n\n/* فقط برای input های متنی و textarea معمولی اعمال شود */\n/* input[type=\"text\"],\ninput[type=\"number\"],\ntextarea:not(#paymentNote) { \n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #333;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  margin: 10px 0;\n\n  &::placeholder {\n    color: #999;\n    font-size: 14px;\n    text-align: right;\n  }\n\n  &:focus {\n    border-color: #EA6C22;\n    box-shadow: 0 0 0 3px rgba(76, 154, 255, 0.2);\n  }\n\n  &:disabled {\n    background-color: #f5f5f5;\n    border-color: #ddd;\n    color: #999;\n    cursor: not-allowed;\n  }\n\n  &.is-error {\n    border-color: #e74c3c;\n    box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.2);\n  }\n} */\n\n/* رادیو باتن ها */\n/* input[type=\"radio\"] {\n  width: auto; \n  height: auto;\n  margin: 0;\n  padding: 0;\n  accent-color: #EA6C22; \n} */\n/* \n#paymentNote {\n  width: 100%;\n  resize: vertical;\n  min-height: 80px;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n} */\n\n.invoice-explanation{\n  margin-top: 30px;\n}\n\n\n\n.radio-label{\n  margin-left: 10px;\n}\n\n\nlabel.checkbox-label {\n    margin-left: 20px;\n}\n\n/* .pagination {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n}\n.page-btn {\n  padding: 0.4rem 0.8rem;\n  border: 1px solid #ccc;\n  background: #fff;\n  cursor: pointer;\n  border-radius: 4px;\n}\n.page-btn.active {\n  background: #007bff;\n  color: #fff;\n  border-color: #007bff;\n}\n\nth,td{\n  text-align: right !important;\n}\n */\n\n/* ================================\n   Table Responsive Scroll Styles\n   ================================ */\n\n/* .table-container {\n  width: 100%;\n  overflow-x: auto; \n  -webkit-overflow-scrolling: touch; \n  scrollbar-width: thin;\n  scrollbar-color: #ccc transparent;\n}\n\n.table-container table {\n  width: 100%; \n  border-collapse: collapse; \n}\n\n.table-container th,\n.table-container td {\n  padding: 0.75rem; \n  text-align: center;\n  white-space: nowrap; \n}\n\n.table-container thead {\n  background: #f5f5f5; \n}\n */\n\n\n@media (max-width:820px) {\n\n .table-container {\n  width: 300px\n \n}\n}\n\n\n.button-group-header-card {\n    display: flex;\n    gap: 10px; /* فاصله بین دکمه‌ها */\n    flex-wrap: nowrap; /* جلوگیری از شکست خط */\n}\n\n\n\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  padding: 10px;\n  font-family: sans-serif;\n\n\n  width: 50%;\n  margin: 20px auto 0 auto; /* ← این باعث وسط شدن افقی میشه */\n}\n\n\n.pagination button {\n  border: none;\n  background-color: #f2f2f2;\n  color: #333;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.pagination button:hover:not(:disabled) {\n  background-color: #e0e0e0;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination button.active {\n  background-color: #EA6C22;\n  color: #fff;\n}\n\n.pagination .dots {\n  padding: 0 6px;\n  color: #999;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.role-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  z-index: 10;\n  min-width: 120px;\n}\n\n.role-dropdown div {\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.role-dropdown div:hover {\n  background-color: #f0f0f0;\n}\n\n\n.dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n  border-radius: 6px;\n  z-index: 100;\n  min-width: 120px;\n}\n\n.dropdown div {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.dropdown div:hover {\n  background: #f0f0f0;\n}\n\n\n\n/* ---------------------------------------------\n 🎯 Search Input Field Styles\n Author: بنیامین حیدرزاده\n Description: Elegant animated search bar with hover/focus effects\n----------------------------------------------*/\n\n.search-container {\n  position: relative;\n  width: 100%;\n  max-width: 360px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  /* 🕶️ subtle fade-in animation */\n  animation: fadeInSearch 0.6s ease forwards;\n}\n\n@keyframes fadeInSearch {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n/* ---------- سرچ باکس ---------- */\n.search-container {\n  position: relative;\n  width: 240px;\n  transition: all 0.3s ease;\n}\n\n.search-container:focus-within {\n  width: 280px; /* بزرگ‌تر شدن هنگام فوکوس */\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.6rem 1rem 0.6rem 2.5rem;\n  border: 1.5px solid #ddd;\n  border-radius: 8px;\n  background: #fff;\n  color: #333;\n  font-size: 15px;\n  outline: none;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.search-input::placeholder {\n  color: #aaa;\n}\n\n.search-input:focus {\n  border-color: #ff6b00;\n  box-shadow: 0 0 0 3px rgba(255, 107, 0, 0.15);\n}\n\n.search-container::before {\n  content: \"\";\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  width: 18px;\n  height: 18px;\n  transform: translateY(-50%);\n  /* background: url(\"/icons/search.svg\") no-repeat center; */\n  background-size: contain;\n  opacity: 0.6;\n  transition: opacity 0.3s ease;\n}\n\n.search-container:hover::before {\n  opacity: 1;\n}\n\n/* ---------- گروه دکمه‌ها ---------- */\n.button-group-header-card {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n/* ---------- ریسپانسیو ---------- */\n@media (max-width: 768px) {\n  .header-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .search-container {\n    width: 100%;\n  }\n\n}\n\n\n\n\n\n\n.scroll-to-top-btn {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background: #ff7a00;\n  color: white;\n  border: none;\n  padding: 0.75rem 1rem;\n  border-radius: 50px;\n  cursor: pointer;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.2);\n  transition: transform 0.2s ease, opacity 0.2s ease;\n  z-index: 1000;\n}\n\n.scroll-to-top-btn:hover {\n  transform: translateY(-3px);\n  opacity: 0.9;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n/* ============================\n  جمع کل محصولات\n============================ */\n.total-amount {\n  font-weight: bold;\n  font-size: 16px;\n  color: #333;\n  margin-top: 1rem;\n}\n\n/* ============================\n  بخش تسویه\n============================ */\n.payment-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.payment-section .remaining-amount {\n  font-weight: bold;\n  font-size: 16px;\n  color: #EA6C22;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  border: 1px solid #EA6C22;\n  background-color: #fff4f0;\n  box-shadow: 0 2px 6px rgba(234,108,34,0.2);\n}\n\n/* ============================\n  چک‌باکس‌ها و جزئیات پرداخت\n============================ */\n.payment-type {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #EA6C22;\n}\n\n.payment-details {\n  margin-top: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-left: 4px solid #EA6C22;\n  border-radius: 8px;\n  background-color: #fff8f3;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.payment-details .form__input,\n.payment-details textarea {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  font-size: 16px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n}\n\n.payment-details .form__input:focus,\n.payment-details textarea:focus {\n  border-color: #EA6C22;\n  box-shadow: 0 0 6px rgba(234,108,34,0.3);\n  outline: none;\n}\n\n.payment-details textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n.payment-error {\n  color: #EA6C22;\n  font-weight: bold;\n  font-size: 14px;\n  margin-top: 0.25rem;\n}\n\n\n\n\n\n\n/* ---------- Simple Tabs ---------- */\n\n.tabs-container {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.tab-button {\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  font-size: 15px;\n  color: #333;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.tab-button:hover {\n  color: #ff6600; /* هاور ساده */\n}\n\n.tab-button.active {\n  font-weight: bold; /* بولد شدن تب فعال */\n  color: #000;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* ===============================\n   📱 Phone Input Floating Label\n================================= */\n.phone-input-container {\n  position: relative;\n  width: 100%;\n  margin: 20px 0;\n}\n\n.phone-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.phone-prefix {\n  position: absolute;\n  left: 1px;\n  color: #888;\n  font-size: 15px;\n  pointer-events: none;\n}\n\n.phone-input {\n  width: 100%;\n  padding: 14px 12px 14px 3rem; /* فضای کافی برای \"09\" */\n  border: 2px solid #a1a1a1;\n  border-radius: 8px;\n  font-size: 15px;\n  direction: ltr;\n  text-align: left;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n  background-color: #fff;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n/* فوکوس */\n.phone-input:focus {\n  outline: none;\n  border-color: #EA6C22;\n  box-shadow: 0 4px 12px rgba(234, 108, 34, 0.3);\n}\n\n/* لیبل شناور */\n.phone-label {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  background-color: #fff;\n  color: #555;\n  font-size: 15px;\n  pointer-events: none;\n  transition: all 0.25s ease-in-out;\n}\n\n/* وقتی فوکوس یا مقدار دارد */\n.phone-input:focus ~ .phone-label,\n.phone-input:not(:placeholder-shown) ~ .phone-label {\n  top: 0;\n  font-size: 13px;\n  color: #EA6C22;\n  padding: 0 6px;\n}\n\n/* حالت خطا */\n.has-error {\n  border-color: #e74c3c !important;\n  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.15);\n}\n\n.phone-error {\n  color: #e74c3c;\n  font-size: 13px;\n  margin-top: 6px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
